module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/zh-hant/3-1f56106b2e921399b5dd6a166cd50589.jpg";